<template>
  <v-card class="filter-panel">
    <h1 class="filter-title">Gestion de Lugares Origen/Destino</h1>
    <v-form ref="form" @submit.prevent="applyFilters" @keydown.enter.prevent="applyFilters">
      <v-row dense>
        <v-col cols="12" md="3">
          <v-text-field label="Filtrar por Nombre de Lugar" v-model="filter.name"/>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field label="Filtrar por Ciudad" v-model="filter.city"/>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field label="Filtrar por Codigo Postal" v-model="filter.postalCode"/>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field label="Filtrar por Direccion" v-model="filter.address"/>
        </v-col>
        <v-col cols="12" md="3">
          <v-select label="Filtrar por Tipo" v-model="filter.typeId" :items="getLocationTypes" item-title="name" item-value="id" clearable/>
        </v-col>
      </v-row>
      <div class="filter-actions">
        <v-btn type="button" @click="clearFilters" color="secondary" variant="tonal">{{ CONST.CLEAN_FILTERS }}</v-btn>
        <v-btn type="submit" color="primary">{{ CONST.APPLY_FILTERS }}</v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterLocationForm',

  data: () => ({
    filter: {
      name: '',
      address: '',
      city: '',
      postalCode: '',
      typeId: null
    }
  }),

  created () {
    this.CONST = CONST
    this.$store.dispatch('locationModule/getLocationTypes')
  },

  computed: {
    ...mapGetters('locationModule', ['getLocations', 'getLocationTypes'])
  },
  watch: {
    getLocations: function () {
      this.$refs.form.reset()
    }
  },

  methods: {
    applyFilters () {
      this.$store.dispatch('locationModule/filterItems', this.filter)
    },

    clearFilters () {
      this.$store.dispatch('locationModule/refreshFilteredLocations')
      this.$refs.form.reset()
    }
  }
}
</script>
